import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-atren-gray text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <Logo variant="white" className="mb-6" />
              <p className="text-white/80 leading-relaxed mb-6 max-w-md">
                Specializirano podjetje za razvoj nepremičnin, investicijsko vodenje projektov 
                in izvajanje premium gradbenih del v Sloveniji.
              </p>
              
              {/* Social Links */}
              <div className="flex space-x-4">
                <a
                  href="https://www.facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  className="w-10 h-10 bg-white/10 hover:bg-atren-orange rounded-lg flex items-center justify-center transition-colors duration-300"
                >
                  <Facebook className="w-5 h-5" />
                </a>
                <a
                  href="https://www.instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                  className="w-10 h-10 bg-white/10 hover:bg-atren-orange rounded-lg flex items-center justify-center transition-colors duration-300"
                >
                  <Instagram className="w-5 h-5" />
                </a>
                <a
                  href="https://www.linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="w-10 h-10 bg-white/10 hover:bg-atren-orange rounded-lg flex items-center justify-center transition-colors duration-300"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Navigacija</h3>
              <ul className="space-y-3">
                {[
                  { name: 'Domov', href: '#domov' },
                  { name: 'Storitve', href: '#storitve' },
                  { name: 'Projekti', href: '#projekti' },
                  { name: 'O nas', href: '#o-nas' },
                  { name: 'Kontakt', href: '#kontakt' },
                ].map((link) => (
                  <li key={link.name}>
                    <button
                      onClick={() => scrollToSection(link.href)}
                      className="text-white/80 hover:text-atren-orange transition-colors duration-300"
                    >
                      {link.name}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-semibold mb-6">Kontakt</h3>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <Phone className="w-5 h-5 text-atren-orange mt-0.5 flex-shrink-0" />
                  <div>
                    <a
                      href="tel:+38670846087"
                      className="text-white/80 hover:text-white transition-colors duration-300"
                    >
                      +386 70 846 087
                    </a>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 text-atren-orange mt-0.5 flex-shrink-0" />
                  <div>
                    <a
                      href="mailto:info@atren.eu"
                      className="text-white/80 hover:text-white transition-colors duration-300"
                    >
                      info@atren.eu
                    </a>
                  </div>
                </li>
                <li className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-atren-orange mt-0.5 flex-shrink-0" />
                  <div>
                    <span className="text-white/80">
                      Partizanska cesta 71d, 6210 Sežana
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-white/60 text-sm">
              © {currentYear} ATREN INVEST. Vse pravice pridržane.
            </div>
            <div className="flex space-x-6 text-sm">
              <Link
                to="/politika-zasebnosti"
                className="text-white/60 hover:text-white transition-colors duration-300"
              >
                Politika zasebnosti
              </Link>
              <Link
                to="/splosni-pogoji"
                className="text-white/60 hover:text-white transition-colors duration-300"
              >
                Splošni pogoji
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;